import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " Once you invite colleagues to complete Viewpoints feedback their perspectives will be shown here ", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "You and your colleagues need more Viewpoints responses to see your Viewpoints section", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 2 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "You need at least two Viewpoints responses to see your Viewpoints section", -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 3,
  class: "custom-viewpoints-bar-graph"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"50px"} }, null, -1)
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "customValuesGraph row cs-accordion-anchor-child" }
const _hoisted_14 = {
  class: "customValuesGraphLabel",
  style: {"line-height":"1","display":"flex","align-items":"center","color":"#404040"}
}
const _hoisted_15 = { class: "customValuesGraphArea" }
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"customValuesCutoff\" style=\"right:0%;\"></div><div class=\"customValuesCutoff\" style=\"right:25%;\"></div><div class=\"customValuesCutoff\" style=\"left:50%;\"></div><div class=\"customValuesCutoff\" style=\"left:25%;\"></div><div class=\"customValuesCutoff\" style=\"left:0%;\"></div>", 5)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-sm-7 text-xs-center text-sm-left" }
const _hoisted_24 = { class: "col-sm-5 text-center" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"20px"} }, "Mean Rating:", -1)
const _hoisted_26 = { style: {"font-size":"50px"} }
const _hoisted_27 = /*#__PURE__*/_createStaticVNode("<div class=\"customValuesGraphXAxis\"><div class=\"customValuesGraphXAxisLabels\"><div class=\"customValuesGraphXAxisLabel\" style=\"left:75%;width:25%;\"> Highly characteristic </div><div class=\"customValuesGraphXAxisLabel\" style=\"left:50%;width:25%;\"> More characteristic </div><div class=\"customValuesGraphXAxisLabel\" style=\"left:25%;width:25%;\"> Less characteristic </div><div class=\"customValuesGraphXAxisLabel\" style=\"left:0%;width:25%;\"> Not characteristic </div></div></div>", 1)

import { computed, Ref, ref, inject } from "vue";
import { Tooltip } from "uiv";
import CustomRow from "./custom-row.interface";
import { CustomSoloReportApiModel } from "../../api-models";


export default /*#__PURE__*/_defineComponent({
  __name: 'custom-viewpoints-bar-graph',
  setup(__props) {

const report = inject("report") as Ref<CustomSoloReportApiModel>;

const values = inject("values") as Ref<string[] | undefined>;

const activeRowId = ref("");

const click = (row: CustomRow | null): void => {
  activeRowId.value = row?.id === activeRowId.value ? "" : row?.id ?? "";
};

function startingActiveRow(rows: CustomRow[]): void {
  activeRowId.value =
    rows.find((row) => row.mean === Math.max(...rows.map((r) => r.mean)))?.id ?? "";
}

const bar = (start: number, end: number, height: number): string => {
  return `position: absolute;
    left: ${start}%;
    right: ${end}%;
    width: ${end - start}%;
    border-top-width: ${height}px;
    height: ${height}px;
    top: ${(50 - height) / 2}px;
    `;
};

const diamond = (x: number): string => {
  const size = 30;

  return `position: absolute;
    left: calc(${x}% - ${size / 2}px);
    width: ${size}px;
    background: white;
    border-width: 5px;
    height: ${size}px;
    transform:rotate(45deg);
    top: 10px;
    `;
};

const marker = (x: number): string => {
  const size = 30;

  return `position: absolute;
    left: ${x}%;
    width: 10px;
    background: white;
    border-width: 5px;
    height: ${size}px;
    top: 10px;
    `;
};

const tooltip = (row: CustomRow, self?: boolean): string => {
  return self
    ? "Your rating"
    : `Your respondents rated ‘${row.shortTitle}’ between ${row.min} and ${row.max} with an average of ${row.mean}`;
};

const score = (id: string, name: string): CustomRow => {
  const statsForItem = report.value?.customStatistics.viewpointsItems.find((i) =>
    i.itemId.includes(id),
  );
  const q1 = Math.round(statsForItem?.lowerQuartile ?? 0);
  const min = statsForItem?.min ?? 0;
  const median = statsForItem?.median ?? 0;
  const q3 = Math.round(statsForItem?.upperQuartile ?? 0);
  const max = statsForItem?.max ?? 0;
  const mean = Math.round(statsForItem?.mean ?? 0);

  const self =
    report.value?.userValues.ratings.find((i) => i.metadata.title === name)?.rawRating ?? 0;

  return {
    id,
    shortTitle: name,
    content: `${values?.value?.find((v) => v.includes(name)) ?? name}`,
    min,
    mean,
    q1,
    median,
    q3,
    max,
    self,
  };
};

const rows = computed(() => {
  if (!report.value) {
    return [];
  }

  const reportRows: CustomRow[] = [];
  report.value.userValues.ratings.forEach((rating) => {
    reportRows.push(score(rating.metadata.id, rating.metadata.title));
  });
  startingActiveRow(reportRows);
  return reportRows;
});

return (_ctx: any,_cache: any) => {
  return (
      _unref(report) &&
      _unref(report).customStatistics.viewpointsItems &&
      _unref(report).customStatistics.viewpointsItems.length === 0
    )
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_unref(report) && !_unref(report).customStatistics.viewpointsItems)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
      : (_unref(report) && _unref(report).customStatistics.viewpointsItems[0].count < 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
        : (_unref(report) && _unref(report).customStatistics.viewpointsItems[0].count >= 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", null, [
                _hoisted_11,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(row.id),
                    key: row.id
                  }, [
                    _createElementVNode("a", {
                      href: "javascript:void(0)",
                      onClick: ($event: any) => (click(row)),
                      class: "a-block customValuesGraphRowAnchor cs-accordion-anchor"
                    }, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", null, _toDisplayString(row.shortTitle), 1)
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _hoisted_16,
                          _createVNode(_unref(Tooltip), {
                            text: tooltip(row)
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                class: "valueGraphBar",
                                style: _normalizeStyle(bar(row.min, row.max, 5))
                              }, null, 4)
                            ]),
                            _: 2
                          }, 1032, ["text"]),
                          _createVNode(_unref(Tooltip), {
                            text: tooltip(row)
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                class: "valueGraphBar",
                                style: _normalizeStyle(diamond(row.mean))
                              }, null, 4)
                            ]),
                            _: 2
                          }, 1032, ["text"]),
                          _createVNode(_unref(Tooltip), {
                            text: tooltip(row, true)
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                class: "valueGraphBar marker",
                                style: _normalizeStyle(marker(row.self))
                              }, null, 4)
                            ]),
                            _: 2
                          }, 1032, ["text"])
                        ])
                      ])
                    ], 8, _hoisted_12),
                    _createElementVNode("div", {
                      class: _normalizeClass([{ hidden: row.id !== activeRowId.value }, "customValuesGraphInfo cs-accordion-panel"])
                    }, [
                      _hoisted_21,
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("p", _hoisted_23, _toDisplayString(row.content), 1),
                        _createElementVNode("div", _hoisted_24, [
                          _hoisted_25,
                          _createElementVNode("p", _hoisted_26, _toDisplayString(row.mean), 1)
                        ])
                      ])
                    ], 2)
                  ], 2))
                }), 128)),
                _hoisted_27
              ])
            ]))
          : _createCommentVNode("", true)
}
}

})